export const contactInfo = {
  phone: '[YOUR PHONE]',
  phoneHref: 'tel:',
  email: 'letmeclean.com@gmail.com',
};

export const steps = [
  { num: '01', title: 'Get an instant price', text: 'Bedrooms, bathrooms, extras. The price you see is the price you pay — no surprise quotes.', icon: 'ri-calculator-line' },
  { num: '02', title: 'Book online', text: 'Pick your date, time window and address, then confirm securely online. Nothing is charged until the cleaning is complete.', icon: 'ri-calendar-check-line' },
  { num: '03', title: 'Come home to clean', text: 'A vetted cleaner arrives with all supplies and works through a detailed checklist.', icon: 'ri-home-smile-line' },
];

export const services = [
  { id: 'standard', title: 'Standard cleaning', price: 119, text: 'Kitchen, bathrooms, dusting, floors, beds. Up to 15% off for weekly visits.', icon: 'ri-sparkling-line', featured: false },
  { id: 'deep', title: 'Deep cleaning', price: 190, text: 'Everything in standard plus baseboards, doors, vents, behind appliances.', icon: 'ri-brush-line', featured: false },
  { id: 'move', title: 'Move-out / move-in', price: 250, text: 'Empty-home clean built for your deposit: inside cabinets, closets, appliances included.', icon: 'ri-truck-line', featured: true },
];

export const addOns = [
  { id: 'oven', label: 'Inside oven', price: 35, icon: 'ri-fire-line' },
  { id: 'fridge', label: 'Inside fridge', price: 35, icon: 'ri-fridge-line' },
  { id: 'cabinets', label: 'Inside cabinets', price: 40, icon: 'ri-archive-drawer-line' },
  { id: 'windows', label: 'Interior windows', price: 50, icon: 'ri-window-line' },
];

export const faqs = [
  { q: 'When is my card charged?', a: 'Only after your cleaning is finished. At booking we just save the card securely — we never see or store your card number.' },
  { q: 'How does the 10% discount work?', a: 'New customers get 10% off their first booking. It\'s applied automatically — no code needed.' },
  { q: 'Can I cancel or reschedule?', a: 'Free up to 48 hours before your visit. Later cancellations: $50.' },
  { q: 'Do I need to provide supplies?', a: 'No. Cleaners bring all supplies and equipment.' },
  { q: 'Which areas do you serve?', a: 'Chicago and Suburbs' },
];